import { render } from "./PageListarDepartamento.vue?vue&type=template&id=05f93597"
import script from "./PageListarDepartamento.vue?vue&type=script&lang=js"
export * from "./PageListarDepartamento.vue?vue&type=script&lang=js"

import "./PageListarDepartamento.vue?vue&type=style&index=0&id=05f93597&lang=css"
/* custom blocks */
import block0 from "./PageListarDepartamento.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__